import { Panel } from '../../../../common/panel'
import { panelTypes } from '../../../../common/panel/constants'
import TableContent from './TableContent'
import { ViewDetails } from './ViewDetails'

export const RecentNews = () => {
  return (
    <Panel
      isI18n
      height={332}
      label="industryOverview.recentNews.RECENT_NEWS"
      renderRightHeader={() => <ViewDetails />}
      type={panelTypes.HALF_SIZE}
    >
      <TableContent />
    </Panel>
  )
}
